var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CToast',{key:("toast-" + (_vm.toast.id)),class:_vm.className,attrs:{"show":_vm.toast.isShow,"header":_vm.toast.header,"title":_vm.toast.title}},[_c('div',[_vm._v(_vm._s(_vm.toast.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }